
import GalleryAdd from "../../../assets/duotone/GalleryAdd.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function GalleryAddIcon({ className, dataTestid = "GalleryAddIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <GalleryAdd data-testid={dataTestid} className={classes} {...rest} />
  );
}
